// ReportProjectProgressCell Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import ProgressBar from '../../../common/common/progress_bar/progress_bar.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'
import CellContainer from '../../../../components/ListCell/CellContainer.jsx'

class ReportProjectProgressCell extends Component {
  static get propTypes () {
    return {
      report: PropTypes.object.isRequired,
      width: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      report: null,
      width: ''
    }
  }

  render () {
    const { report, width } = this.props
    let bShowWarning = false
    let perc = 0

    if (report.value > 0 && report.totalValue > 0) {
      perc = parseFloat(((report.value / report.totalValue) * 100).toFixed())
    } else if (report.value < 0) {
      if (report.totalValue > 0) {
        perc =
          parseFloat(((report.value / report.totalValue) * 100).toFixed()) * -1
      }
      bShowWarning = true
    }
    const _className = classnames(
      'report-project-progresscell list-cell',
      {},
      `${report.status.toLowerCase()}${bShowWarning ? ' warning' : ''}`
    )

    return (
      <CellContainer width={width} className={_className}>
        <div className='listrowcell'>
          <div className='cont'>
            <ProgressBar
              value={perc}
              mode='determinate'
              className={bShowWarning ? 'progress-bar-warning' : ''}
              max={100}
              buffer={100}
              type='linear'
            />
            <div className='info'>
              <div className='value'>
                <PriceText value={report.value} />
              </div>
              <div className='totalvalue'>
                <PriceText value={report.totalValue} />
              </div>
            </div>
          </div>
        </div>
      </CellContainer>
    )
  }
}

export default ReportProjectProgressCell
